import { render, staticRenderFns } from "./x-table.vue?vue&type=template&id=201f3b38&scoped=true&"
import script from "./x-table.vue?vue&type=script&lang=js&"
export * from "./x-table.vue?vue&type=script&lang=js&"
import style0 from "./x-table.vue?vue&type=style&index=0&lang=css&"
import style1 from "./x-table.vue?vue&type=style&index=1&id=201f3b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f3b38",
  null
  
)

export default component.exports